import { BrowserRouter as Router } from 'react-router-dom';

import { FeatureFlagsProvider } from '@project44/feature-flags';
import { ReactHooksApplication } from '@project44/iam-team-ui-utils';
import { RequireTranslations } from '@project44/translations-utils';
import { getP44Env, User, useUser } from '@project44/ui-utils';

import { translations } from '../l10n/config';
import { SideBarSkeleton } from './components/SideBar';
import { SideBar as MovementSideBar } from './movement';
import { PACKAGE_NAME } from './utils/constants/PACKAGE_NAME';

export function App() {
  const { tenantHookController } = ReactHooksApplication.getInstance();
  const { data } = useUser();

  const [TenantSwitcherComponent, toggleTenantSwitcherComponent] =
    tenantHookController.composeUseToggleTenantSwitcherComponent({
      user: data,
    })();

  return (
    <Router>
      <MovementSideBar
        toggleTenantSwitcherComponent={toggleTenantSwitcherComponent}
      />

      <TenantSwitcherComponent />
    </Router>
  );
}

const isAMovementUrl = (url: string): boolean => {
  const { MOVEMENT_BASE_URL } = getP44Env();

  url = url.toLowerCase().replace(/^(https?:\/\/|)/i, '');
  const movementBaseUrl = MOVEMENT_BASE_URL.toLowerCase().replace(
    /^(https?:\/\/|)/i,
    '',
  );
  return url.startsWith(movementBaseUrl);
};

const shouldHideSideBar = (loggedInUser?: User) => {
  const nonMovementReferrer = new URLSearchParams(window.location.search).get(
    'nonMovementReferrer',
  );
  const afterLoginRedirect: string =
    loggedInUser?.customerProperties.DEFAULT_LANDING_URL_AFTER_LOGIN || '';
  const isNonMovementReferrer = nonMovementReferrer?.toLowerCase() === 'true';
  return isNonMovementReferrer && !isAMovementUrl(afterLoginRedirect);
};

export default function AppProvider() {
  const { data } = useUser();

  return shouldHideSideBar(data) ? (
    <></>
  ) : (
    <RequireTranslations namespace={PACKAGE_NAME} translations={translations}>
      <FeatureFlagsProvider loadingComponent={<SideBarSkeleton />}>
        <App />
      </FeatureFlagsProvider>
    </RequireTranslations>
  );
}
